var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics"},_vm._l((_vm.statistics),function(statistic,index){return _c('span',{key:index},[_c('span',[_vm._v(_vm._s(statistic.name))]),_c('span',[_vm._v(_vm._s(statistic.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }